export default "__VITE_ASSET___2moW6QA__"